import { RequestConfig } from '@/interface'

const PRIFIX = 'common/emailInfo/'
const mailboxConfig: RequestConfig = {
  // 删除邮箱
  delEmail: {
    url: `${PRIFIX}delEmail`, // id
    method: 'post'
  },
  // 邮箱列表
  emailList: {
    url: `${PRIFIX}emailList`,
    method: 'post'
  },
  // saveOrUpdate
  emailSaveOrUpdate: {
    url: `${PRIFIX}saveOrUpdate`,
    method: 'post'
  },
  // 发邮件测试
  sendEmailTest: {
    url: `${PRIFIX}sendEmailTest`,
    method: 'post'
  },
  // 启用、停用 status:1-启用，0-停用
  emailUpdStatus: {
    url: `${PRIFIX}updStatus`, // /{id}/{status}
    method: 'get'
  },
  getEmailInfo: {
    url: `${PRIFIX}getEmailInfo`, // /${id}
    method: 'get'
  }
}
export default mailboxConfig
